import {
    CoachingRole,
    CommitmentApprovalDto,
    CommitmentDto,
    EventParticipantDto,
} from '../coaching-base/general';
import {
    ApproveContext,
    CloseContext,
    CommitmentApproveContext,
    CommitmentCloseDidApproveContext,
    CommitmentCloseDidSignOffContext,
    CommitmentDisputeContext,
    CommitmentUpdateDidSignOffContext,
    DeleteContext,
    DisputeContext,
    GoalCloseContext,
    NewCmtSendApprovalContext,
    NotificationContext,
    NotificationDispatchDto,
    NotificationScenario,
    PublishContext,
    SignOffContext,
} from '../coaching-base/notifications';

import { determineNotificationAddress } from './determine-notification-address';

export function createNotification(
    userId: number,
    scenario: NotificationScenario,
    ctx: any,
    approval: CommitmentApprovalDto,
    commitment: CommitmentDto,
    participants: EventParticipantDto[],
): NotificationDispatchDto {
    const performer = (participants || []).find(
        (e) => e.coachingRoleId === CoachingRole.PERFORMER,
    );
    let url: string;
    ctx = ctx || {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const context = {} as NotificationContext;
    const { from, to } = determineNotificationAddress(userId, participants);

    const approvalScenarios = [
        NotificationScenario.PUBLISH,
        NotificationScenario.CLOSE,
        NotificationScenario.DISPUTE,
        NotificationScenario.GOAL_CLOSE,
        NotificationScenario.APPROVE,
        NotificationScenario.SIGN_OFF,
        NotificationScenario.COMMITMENT_CLOSE_DID_APPROVE,
        NotificationScenario.COMMITMENT_UPDATE_DID_SIGN_OFF,
        NotificationScenario.COMMITMENT_DISPUTE,
        NotificationScenario.COMMITMENT_APPROVE,
        NotificationScenario.NEW_COMMITMENT_SEND_APPROVAL,
        NotificationScenario.UPDATE_COMMITMENT_DISPUTE,
    ];
    if (approvalScenarios.includes(scenario)) {
        url =
            commitment.commitmentId != null
                ? `/coaching-detail/${performer.id}/commitments/${commitment.commitmentId}/drafts/${approval.draftId}/approvals/${approval.approvalId}`
                : `/coaching-detail/${performer.id}/draftcommitments/${approval.draftId}/approvals/${approval.approvalId}`;
    } else {
        url = `/coaching-detail/${performer.id}/commitments/${commitment.commitmentId}`;
    }

    switch (scenario) {
        case NotificationScenario.PUBLISH:
            // eslint-disable-next-line no-case-declarations
            const pc = context as PublishContext;
            pc.behaviourId = ctx.behaviourId;
            pc.subBehaviourId = ctx.subBehaviourId;
            pc.url = url;
            break;
        case NotificationScenario.CLOSE:
            // eslint-disable-next-line no-case-declarations
            const cc = context as CloseContext;
            cc.behaviourId = ctx.behaviourId;
            cc.subBehaviourId = ctx.subBehaviourId;
            cc.url = url;
            break;
        case NotificationScenario.DISPUTE:
            // eslint-disable-next-line no-case-declarations
            const dc = context as DisputeContext;
            dc.behaviourId = ctx.behaviourId;
            dc.subBehaviourId = ctx.subBehaviourId;
            dc.reason = ctx.reason;
            dc.comment = ctx.comment;
            dc.url = url;
            break;
        case NotificationScenario.GOAL_ACCEPT:
            break;
        case NotificationScenario.GOAL_CLOSE:
            // eslint-disable-next-line no-case-declarations
            const gcc = context as GoalCloseContext;
            gcc.behaviourId = ctx.behaviourId;
            gcc.subBehaviourId = ctx.subBehaviourId;
            gcc.requestDate = new Date();
            gcc.metricId = ctx.metricId;
            gcc.goalValue = ctx.goalValue;
            gcc.goalMet = ctx.percentToGoal <= 0;
            gcc.percentToGoal = ctx.percentToGoal;
            gcc.url = url;
            break;
        case NotificationScenario.APPROVE:
            // eslint-disable-next-line no-case-declarations
            const ac = context as ApproveContext;
            ac.behaviourId = ctx.behaviourId;
            ac.subBehaviourId = ctx.subBehaviourId;
            ac.firstName = from.firstName;
            ac.lastName = from.lastName;
            ac.url = url;
            break;
        case NotificationScenario.DELETE:
            // eslint-disable-next-line no-case-declarations
            const dec = context as DeleteContext;
            dec.firstName = from.firstName;
            dec.lastName = from.lastName;
            dec.sessionDate = ctx.sessionDate;
            break;
        case NotificationScenario.SIGN_OFF:
            // eslint-disable-next-line no-case-declarations
            const sc = context as SignOffContext;
            sc.behaviourId = ctx.behaviourId;
            sc.subBehaviourId = ctx.subBehaviourId;
            sc.sessionDate = ctx.sessionDate;
            sc.url = url;
            break;
        case NotificationScenario.COMMITMENT_CLOSE_DID_SIGN_OFF:
            // eslint-disable-next-line no-case-declarations
            const ccdsc = context as CommitmentCloseDidSignOffContext;
            ccdsc.behaviourId = ctx.behaviourId;
            ccdsc.subBehaviourId = ctx.subBehaviourId;
            ccdsc.sessionDate = ctx.sessionDate;
            ccdsc.url = url;
            break;
        case NotificationScenario.COMMITMENT_CLOSE_DID_APPROVE:
            // eslint-disable-next-line no-case-declarations
            const ccdac = context as CommitmentCloseDidApproveContext;
            ccdac.behaviourId = ctx.behaviourId;
            ccdac.subBehaviourId = ctx.subBehaviourId;
            ccdac.firstName = from.firstName;
            ccdac.lastName = from.lastName;
            ccdac.url = url;
            break;
        case NotificationScenario.COMMITMENT_UPDATE_DID_SIGN_OFF:
            // eslint-disable-next-line no-case-declarations
            const cudsc = context as CommitmentUpdateDidSignOffContext;
            cudsc.behaviourId = ctx.behaviourId;
            cudsc.subBehaviourId = ctx.subBehaviourId;
            cudsc.sessionDate = ctx.sessionDate;
            cudsc.url = url;
            break;
        case NotificationScenario.COMMITMENT_DISPUTE:
            // eslint-disable-next-line no-case-declarations
            const cudc = context as CommitmentDisputeContext;
            cudc.behaviourId = ctx.behaviourId;
            cudc.subBehaviourId = ctx.subBehaviourId;
            cudc.firstName = from.firstName;
            cudc.lastName = from.lastName;
            cudc.url = url;
            break;
        case NotificationScenario.COMMITMENT_APPROVE:
            // eslint-disable-next-line no-case-declarations
            const cuac = context as CommitmentApproveContext;
            cuac.behaviourId = ctx.behaviourId;
            cuac.subBehaviourId = ctx.subBehaviourId;
            cuac.firstName = from.firstName;
            cuac.lastName = from.lastName;
            cuac.url = url;
            break;
        case NotificationScenario.NEW_COMMITMENT_SEND_APPROVAL:
            // eslint-disable-next-line no-case-declarations
            const ncsac = context as NewCmtSendApprovalContext;
            ncsac.behaviourId = ctx.behaviourId;
            ncsac.subBehaviourId = ctx.subBehaviourId;
            ncsac.url = url;
            break;
        case NotificationScenario.UPDATE_COMMITMENT_DISPUTE:
            // eslint-disable-next-line no-case-declarations
            const ucdc = context as CommitmentDisputeContext;
            ucdc.behaviourId = ctx.behaviourId;
            ucdc.subBehaviourId = ctx.subBehaviourId;
            ucdc.firstName = from.firstName;
            ucdc.lastName = from.lastName;
            ucdc.url = url;
            break;
    }

    return {
        scenario,
        fromUserId: from.id,
        toUserIds: [to.id],
        context,
    };
}
